import { render, staticRenderFns } from "./Vizsgadij.vue?vue&type=template&id=13b0e27e&lang=html&"
import script from "./Vizsgadij.vue?vue&type=script&lang=js&"
export * from "./Vizsgadij.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports